import { Box, Flex, Image, Text, Title } from "@mantine/core";
import { LayoutProps } from "types/ui";

const ImageMessage = ({ imgSrc, title, description }: LayoutProps) => {
  return (
    <Flex align="center">
      <Box component="div" flex={1}>
        <Image radius="md" src={imgSrc || '/invite-accept.png'} />
      </Box>
      <Box component="div" flex={1}>
        <Title size="2.5rem" c="black" pb={50}>
          {title}
        </Title>
        <Text size="lg" pb="lg" component="div">
          {description}
        </Text>
      </Box>
    </Flex>
  );
};

export default ImageMessage;
